import React from 'react';
import {
    NewAdminIcon,
    NewGroupsIcon,
    NewHomeIcon, NewLeadersIcon,
    NewMembersIcon, NewMoreIcon, NewNotificationsIcon,
    NewProfileIcon,
    NewMagnifyingGlassIcon,
    NewSettingsIcon,
    NewMessagesIcon, NewCalendarIcon
} from "./icons";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import SimpleTooltip from "../tooltip";
import {QuestionMarkCircleIcon,RocketLaunchIcon} from "@heroicons/react/24/outline";

const SidebarIcon = () => {
    return <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M6.27218 1.90039L11.7247 1.90039C12.5425 1.90039 13.1929 1.90038 13.7177 1.94326C14.2551 1.98716 14.7133 2.079 15.1328 2.29277C15.8102 2.63791 16.3609 3.18864 16.7061 3.86602C16.9198 4.28557 17.0117 4.74378 17.0556 5.28114C17.0984 5.80589 17.0984 6.45632 17.0984 7.27415V10.7266C17.0984 11.5445 17.0984 12.1949 17.0556 12.7196C17.0117 13.257 16.9198 13.7152 16.7061 14.1348C16.3609 14.8121 15.8102 15.3629 15.1328 15.708C14.7133 15.9218 14.2551 16.0136 13.7177 16.0575C13.1929 16.1004 12.5425 16.1004 11.7247 16.1004H6.2722C5.45436 16.1004 4.80394 16.1004 4.27918 16.0575C3.74182 16.0136 3.28362 15.9218 2.86407 15.708C2.18669 15.3629 1.63596 14.8121 1.29081 14.1348C1.07704 13.7152 0.985207 13.257 0.941303 12.7196C0.898429 12.1949 0.898433 11.5445 0.898438 10.7266L0.898438 7.27414C0.898433 6.45631 0.898429 5.80589 0.941303 5.28114C0.985207 4.74378 1.07704 4.28557 1.29081 3.86602C1.63596 3.18864 2.18669 2.63791 2.86407 2.29277C3.28362 2.079 3.74182 1.98716 4.27918 1.94326C4.80394 1.90038 5.45436 1.90039 6.27218 1.90039ZM4.3769 3.13927C3.91375 3.17711 3.63105 3.24877 3.40886 3.36198C2.95727 3.59207 2.59012 3.95922 2.36002 4.41081C2.24681 4.633 2.17516 4.9157 2.13732 5.37886C2.0989 5.84901 2.09844 6.45041 2.09844 7.30039L2.09844 10.7004C2.09844 11.5504 2.0989 12.1518 2.13732 12.6219C2.17516 13.0851 2.24681 13.3678 2.36002 13.59C2.59012 14.0416 2.95727 14.4087 3.40886 14.6388C3.63105 14.752 3.91375 14.8237 4.3769 14.8615C4.84706 14.8999 5.44846 14.9004 6.29844 14.9004L11.6984 14.9004C12.5484 14.9004 13.1498 14.8999 13.62 14.8615C14.0831 14.8237 14.3658 14.752 14.588 14.6388C15.0396 14.4087 15.4068 14.0416 15.6369 13.59C15.7501 13.3678 15.8217 13.0851 15.8596 12.6219C15.898 12.1518 15.8984 11.5504 15.8984 10.7004L15.8984 7.30039C15.8984 6.45041 15.898 5.84901 15.8596 5.37886C15.8217 4.9157 15.7501 4.633 15.6369 4.41081C15.4068 3.95922 15.0396 3.59207 14.588 3.36198C14.3658 3.24877 14.0831 3.17711 13.62 3.13927C13.1498 3.10086 12.5484 3.10039 11.6984 3.10039L6.29844 3.10039C5.44846 3.10039 4.84706 3.10086 4.3769 3.13927Z"
              fill="currentColor" data-hovering="false"></path>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M7.19531 15.2246L7.19531 2.72461H8.39531L8.39531 15.2246H7.19531Z" fill="currentColor"
              data-hovering="false"
        ></path>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M3.375 5.42617C3.375 5.0948 3.64363 4.82617 3.975 4.82617H5.325C5.65637 4.82617 5.925 5.0948 5.925 5.42617C5.925 5.75754 5.65637 6.02617 5.325 6.02617H3.975C3.64363 6.02617 3.375 5.75754 3.375 5.42617Z"
              fill="currentColor" data-hovering="false"></path>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M3.375 7.67422C3.375 7.34285 3.64363 7.07422 3.975 7.07422H5.325C5.65637 7.07422 5.925 7.34285 5.925 7.67422C5.925 8.00559 5.65637 8.27422 5.325 8.27422H3.975C3.64363 8.27422 3.375 8.00559 3.375 7.67422Z"
              fill="currentColor" data-hovering="false"></path>
    </svg>
}

const DragHandle = () => {
    return <svg fill="currentColor" x="0" y="0" viewBox="0, 0, 24, 24">
        <g id="Layer_15">
            <path
                d="M8.5,14 C7.395,14 6.5,13.105 6.5,12 C6.5,10.895 7.395,10 8.5,10 C9.605,10 10.5,10.895 10.5,12 C10.5,13.105 9.605,14 8.5,14 z"/>
            <path
                d="M15.5,14 C14.395,14 13.5,13.105 13.5,12 C13.5,10.895 14.395,10 15.5,10 C16.605,10 17.5,10.895 17.5,12 C17.5,13.105 16.605,14 15.5,14 z"/>
            <path
                d="M8.5,20 C7.395,20 6.5,19.105 6.5,18 C6.5,16.895 7.395,16 8.5,16 C9.605,16 10.5,16.895 10.5,18 C10.5,19.105 9.605,20 8.5,20 z"/>
            <path
                d="M15.5,20 C14.395,20 13.5,19.105 13.5,18 C13.5,16.895 14.395,16 15.5,16 C16.605,16 17.5,16.895 17.5,18 C17.5,19.105 16.605,20 15.5,20 z"/>
            <path
                d="M8.5,8 C7.395,8 6.5,7.105 6.5,6 C6.5,4.895 7.395,4 8.5,4 C9.605,4 10.5,4.895 10.5,6 C10.5,7.105 9.605,8 8.5,8 z"/>
            <path
                d="M15.5,8 C14.395,8 13.5,7.105 13.5,6 C13.5,4.895 14.395,4 15.5,4 C16.605,4 17.5,4.895 17.5,6 C17.5,7.105 16.605,8 15.5,8 z"/>
        </g>
    </svg>
}

export const menu_icon_map = {
    'sidebar': <SidebarIcon/>,
    'home': <NewHomeIcon/>,
    'contacts': <NewMembersIcon/>,
    'members': <NewMembersIcon/>,
    'search': <NewMagnifyingGlassIcon/>,
    'explore': <NewMagnifyingGlassIcon/>,
    'groups': <NewGroupsIcon/>,
    'profile': <NewProfileIcon/>,
    'settings': <NewSettingsIcon/>,
    'messages': <NewMessagesIcon/>,
    'calendar': <NewCalendarIcon/>,
    'more': <NewMoreIcon/>,
    'leaders': <NewLeadersIcon/>,
    'admin': <NewAdminIcon/>,
    'drag-handle': <DragHandle/>,
    'grab-handle': <DragHandle/>,
    'notifications': <NewNotificationsIcon/>,
    'help': <QuestionMarkCircleIcon/>,
    'getstarted': <RocketLaunchIcon/>
};

function MenuItemBadge({top, color, right}) {
    return <div className={`absolute ${top} ${right} bg-white h-4 w-4 rounded-full flex items-center justify-center`}>
        <div className={`${color} h-2.5 w-2.5 rounded-full`}/>
    </div>
}

function MenuItem({active, label, loading, onClick, badge, color = "#3c81f6", icon = 'home'}) {
    const is_mobile = window.innerWidth < 821;

    if (loading) {
        return <div className="relative group cursor-pointer" style={{height: '60px'}}>
            <div className="flex items-center h-full justify-center">
                <div className="w-7 h-7 rounded-lg bg-gray-200"/>
            </div>
        </div>
    }

    const content = <div onClick={() => {
        if (onClick) {
            onClick();
        }
    }} className="relative group pt-px cursor-pointer" style={{height: '48px'}}>

        <div className="flex flex-col items-center h-full justify-center">
            <div style={{color}}
                 className={`relative udk-menuicon ${active ? "is_active" : "group-hover:text-gray-800 text-gray-600"} `}>
                {menu_icon_map[icon]}
                {badge && <MenuItemBadge {...badge} />}
            </div>


        </div>

    </div>

    if (!label) {
        return content;
    }

    if (is_mobile) {
        return content;
    }

    return <SimpleTooltip hideOnMobile placement='bottom' text={label}>
        {content}
    </SimpleTooltip>
}


function HomeItems({loading, p, domain, goTo, color}) {
    return <MenuItem label="Home" onClick={() => goTo(`/c/${domain}/home`)} loading={loading} color={color}
                      active={p === `/c/${domain}/home`}/>
}


function MemberProfileItem({p, loading, domain, goTo, color}) {
    const path = domain ? `/c/${domain}/you` : `/you`;
    return <>
        <MenuItem label="You" active={p === path} onClick={() => {
            goTo(path);
        }} loading={loading}
                  color={color} icon="profile"/>
    </>
}
export function MobileMenu({color, unread, community, is_logged_in, profile_path, loading}) {
    const {domain} = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    function goTo(path) {
        return navigate(path)
    }

    const p = location.pathname;

    const mpl = {
        loading, color, p, profile_path, unread,
        is_logged_in, goTo, domain
    };

    const search_active = community ? p === `/c/${community.domain}/search` : p === '/search';
    const calendar_active = community ? p === `/c/${community.domain}/calendar` : p === '/calendar';
    const contacts_active = community ? p === `/c/${community.domain}/contacts` : p === '/contacts';
    const search_goto = community ? `/c/${community.domain}/search` : '/search';
    const calendar_goto = community ? `/c/${community.domain}/calendar` : '/calendar';
    const contacts_goto = community ? `/c/${community.domain}/contacts` : '/contacts';

    // {is_logged_in && <NotificationsItems {...mpl}  />}
    /*
       {is_logged_in && <MenuItem active={p === more_path} onClick={() => {
            navigate(more_path);
        }} loading={loading} icon="more" color={color}/>}
     */
    // {is_logged_in && <MemberProfileItem {...mpl} />}
    return <div
        className="grid w-screen udk-menublur fixed bottom-0 border-t border-gray-200 right-0 left-0 z-40 sm:hidden udk-mm-mobile udk-mm-menugrid">
        <HomeItems {...mpl} />

        {community&&<MenuItem label="Search" active={search_active} onClick={() => goTo(search_goto)}
                  loading={loading} color={color}
                  icon="search"/>}

        {community && <MenuItem label="Contacts" active={contacts_active} onClick={() => goTo(contacts_goto)}
                  loading={loading} color={color}
                  icon="contacts"/>}

        {community && <MenuItem label="Calendar" active={calendar_active} onClick={() => goTo(calendar_goto)}
                                loading={loading} color={color}
                                icon="calendar"/>}

        {is_logged_in && <MemberProfileItem {...mpl} />}
    </div>
}